<template>
  <el-container class="container">
    
    <el-header class="header" :height="`${headerHeight}px`">
      <PrintHeader></PrintHeader>
    </el-header>
    <el-container>
      <el-aside class="aside" :width="`${leftAsideWidth}px`">
        <PrintDragAside></PrintDragAside>
      </el-aside>
      <el-main class="main" :style="mainStyle">
        <el-Scrollbar class="scrollbar">
          <PrintBody></PrintBody>
          <!-- <Test></Test> -->
        </el-Scrollbar>
      </el-main>
      <el-aside class="aside" :width="`${rightAsideWidth}px`">
        <PrintSetingAside></PrintSetingAside>
      </el-aside>
    </el-container>
  </el-container>
</template>

<script>
import ResizeHandler from "./mixin/ResizeHandler";
import PrintBody from "./PrintBody.vue";
import PrintHeader from "./PrintHeader.vue";
import PrintDragAside from "./PrintDragAside.vue";
import PrintSetingAside from "./PrintSetingAside.vue";
import Test from "./Test.vue";
export default {
  name: "VuePrint",
  data() {
    return {
      mainStyle: {
        width: "",
        height: "",
      },
      headerHeight: 50,
      leftAsideWidth: 300,
      rightAsideWidth: 300,
    };
  },
  mixins: [ResizeHandler],
  watch: {
    styleResize: {
      handler: function (val) {
        // 6 为margin
        this.mainStyle.width =
          val.width - this.leftAsideWidth - this.rightAsideWidth - 6 + "px";
        // 6 为margin
        this.mainStyle.height = val.height - this.headerHeight - 6 + "px";
      },
      deep: true,
    },
  },
  components: {
    PrintBody,
    Test,
    PrintHeader,
    PrintDragAside,
    PrintSetingAside,
  },
};
</script>
<style scoped>
.container {
  background: #d8dbe3;
}
.main {
  padding: 0;
  margin: 3px;
  /* background: red !important; */
  position: relative;
}
.header {
  background: #fff;
}
.aside {
  background: #fff;
  margin: 3px 0;
}
</style>
<style  scoped lang='less'>
.scrollbar {
  width: 100%;
  height: 100%;
}
/deep/.el-scrollbar__wrap {
  // -ms-overflow-style: none; /* IE and Edge */
  // scrollbar-width: none; /* Firefox */
  // scrollbar-color: transparent transparent;
  // &::-webkit-scrollbar {
  //   display: none; /* Chrome, Safari, Opera */
  // }
}
</style>